import React, { Component } from "react";
import { ListGroup, Container, Button } from "react-bootstrap";
import ContactForm from "./contact-form";
import Footer from "./footer";
import { Download } from "react-bootstrap-icons";
import styled from "styled-components";

import FBCPdf1 from "./Fluke-User-Manuals/177-efsp-datasheet.pdf";
import FBCPdf2 from "./Fluke-User-Manuals/DVM177-User-Manual.pdf";
import FBCPdf3 from "./Fluke-User-Manuals/ESA612-Datasheet.pdf";
import FBCPdf4 from "./Fluke-User-Manuals/ESA612-Getting-Started-Manual.pdf";
import FBCPdf5 from "./Fluke-User-Manuals/ESA612-User-Manual.pdf";
import ISOCert from "./certs/Nipro_ISO_13485_219725.260120_Certificate.pdf";
import MotorShieldPDF from "./HSMotorShield/H&SMotorShieldInstallationInstructions.pdf";
import ValveAdjustmentPDF from "./msds/H&SValveRebuildInstructions.pdf";
import BBRAUNCatalog from "./msds/catalogs/HSNipro_BBRAUN_Catalog_20230216_RevA.pdf";

import FreseniusCatalog from "./msds/catalogs/HSNipro_Fresenius_Catalog_20230117.pdf";
// import GambroCatalog from "./msds/catalogs/HSNipro_Gambro_Catalog_20231117.pdf";
import MeterCalCatalog from "./msds/catalogs/HSNipro_Calibration_Catalog_20231214.pdf";
import ProductCatalog from "./msds/catalogs/HSNipro_Exclusive_Products_Catalog_20230110.pdf";
import Genius614Marketing from "./msds/NIPRO_Technical_Genius_614_Marketing_Flyer_RevA.pdf";
import SurdialDXHemodialysisSystem from "./msds/SURDIAL DX Hemodialysis System.pdf";
import SDXBrochureClinical from "./msds/SDX/NiproHemodialysisSystemBookletClinical.pdf";
import SDXBrochureBiomed from "./msds/SDX/NiproHemodialysisSystemBookletBiomed.pdf";

import SymbolsGlossary from "./policies/SM_FRM_3000F2_RevA.pdf"

const StyledDownload = styled(Download)`
  margin-right: 20px;
`;
const StyledContainer = styled(Container)`
  margin-top: 75px;
`;

class downloadsPage extends Component {
  render() {
    return (
      <div>
        <div class="jumbotron">
          <StyledContainer>
            <h2>Product & Pricing Information</h2>
            <br></br>
            <ListGroup>
              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>
                NIPRO Technical Solutions Parts Catalogs
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={ProductCatalog + "?pdf=product%2catalog%20230110"}
                  download
                ><StyledDownload size={20} />
                  Exclusive Product Catalog_20230110
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={FreseniusCatalog + "?pdf=fresenius%2catalog%20230117"}
                  download
                ><StyledDownload size={20} />
                  Fresenius Catalog_20230117
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={
                    MeterCalCatalog + "?pdf=meter%2calibration%2catalog%20231214"
                  }
                  download
                ><StyledDownload size={20} />
              Meter Calibration Catalog_20231214
                </a>
              </ListGroup.Item>

              <ListGroup.Item>
                <a
                  href={BBRAUNCatalog + "?pdf=bbraun%2catalog%2200131"}
                  download
                ><StyledDownload size={20} />
               BBRAUN Catalog_20230216
                </a>
              </ListGroup.Item>
              {/*
              <ListGroup.Item>
                <a
                  href={GambroCatalog + "?pdf=bbraun%2catalog%20231117"}
                  download
                ><StyledDownload size={20} />
                     Gambro Catalog_20231117
                </a>
              </ListGroup.Item>
            */}
              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>
              NIPRO Technical Solutions Product Information
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SurdialDXHemodialysisSystem + "?pdf=Surdial%2DX%2Hemodialysis"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL™ DX Hemodialysis System Brochure
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SDXBrochureClinical + "?pdf=Surdial%2DX%Clinical"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL™ DX Hemodialysis System Booklet (Clinical)
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SDXBrochureBiomed + "?pdf=Surdial%2DX%Biomed"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL™ DX Hemodialysis System Booklet (Biomed)
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={Genius614Marketing + "?pdf=H&S%2Genius614%2information"}
                  download
                ><StyledDownload size={20} />
                  Genius 614 Information
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={MotorShieldPDF + "?pdf=motor%2shield%2information"}
                  download
                ><StyledDownload size={20} />
                  Motor Shield Information
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={ValveAdjustmentPDF + "?pdf=valve%rebuild%instructions"}
                  download
                ><StyledDownload size={20} />
                  Valve Rebuild Instructions
                </a>
              </ListGroup.Item> 

              
              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>User Manuals</ListGroup.Item>
              <ListGroup.Item>
                <b>Fluke Biomedical:</b>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={FBCPdf4 + "?pdf=fluke_esa_612_getting_started_manual"}
                  download
                >
                  <StyledDownload size={20} />
                  Fluke ESA 612 Getting Started Manual
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a href={FBCPdf5 + "?pdf=fluke_esa_612_user_manual"} download>
                  <StyledDownload size={20} />
                  Fluke ESA 612 User Manual
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a href={FBCPdf2 + "?pdf=fluke_dvm_177_user_manual"} download>
                  <StyledDownload size={20} />
                  Fluke DVM 177 User Manual
                </a>
              </ListGroup.Item>

              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>
                Specification Data
              </ListGroup.Item>
              <ListGroup.Item>
                <b>Fluke Biomedical:</b>
              </ListGroup.Item>

              <ListGroup.Item>
                <a href={FBCPdf3 + "?pdf=fluke_esa_612_data_sheet"} download>
                  <StyledDownload size={20} />
                  Fluke ESA 612 Data Sheet
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a href={FBCPdf1 + "?pdf=fluke_177_efsp_data_shee"} download>
                  <StyledDownload size={20} />
                  Fluke 177 EFSP Data Sheet
                </a>
              </ListGroup.Item>

              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>Certifications</ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={ISOCert + "?pdf=iso_13485_certificate_of_registration"}
                  download
                >
                  <StyledDownload size={20} />
                  ISO 13485 Certificate of Registration
                </a>
              </ListGroup.Item>

            </ListGroup>
            <em class="italicsFootnote">*Prices are subject to change.</em>
          </StyledContainer>
        </div>
        <ContactForm />
        <Footer />
      </div>
    );
  }
}

export default downloadsPage;
